// src/pages/AISolutionsPage.jsx
import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";

const MatrixBackground = () => {
  useEffect(() => {
    const canvas = document.getElementById("matrix-ai-bg");
    const context = canvas.getContext("2d");

    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    const katakana = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン";
    const latin = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const nums = "0123456789";
    const alphabet = katakana + latin + nums;
    const fontSize = 16;
    const columns = width / fontSize;
    const rainDrops = new Array(Math.floor(columns)).fill(1);

    const draw = () => {
      context.fillStyle = "rgba(0, 0, 0, 0.05)";
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#0F0";
      context.font = fontSize + "px monospace";

      for (let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        context.fillText(text, i * fontSize, rainDrops[i] * fontSize);
        if (rainDrops[i] * fontSize > height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        }
        rainDrops[i]++;
      }
    };

    const interval = setInterval(draw, 30);

    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <canvas
      id="matrix-ai-bg"
      className="fixed top-0 left-0 w-full h-full opacity-20 pointer-events-none"
    />
  );
};

const AISolutionsPage = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen bg-gray-900 text-white overflow-hidden">
      <NavBar />
      <MatrixBackground />
      <div className="relative z-10 container mx-auto px-4 py-16">
        {/* Header */}
        <header
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h1 className="text-5xl font-bold font-mono text-green-500 mb-4">
            AI Solutions
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            At AIOrbis, our AI Solutions empower businesses by integrating advanced machine learning and artificial intelligence strategies. We transform raw data into actionable insights that drive innovation.
          </p>
        </header>

        {/* Expertise */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-8 text-center">
            Our AI Expertise
          </h2>
          <p className="text-gray-300 text-center">
            From natural language processing to predictive analytics, our expert team delivers end-to-end AI solutions tailored to your business needs.
          </p>
        </section>

        {/* Process */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-8 text-center">
            Our Process
          </h2>
          <div className="max-w-4xl mx-auto border-l-2 border-green-500 pl-6">
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Data Collection & Analysis
              </h3>
              <p className="text-gray-300 mt-2">
                We begin by gathering and analyzing your data to uncover valuable insights.
              </p>
            </div>
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Model Development
              </h3>
              <p className="text-gray-300 mt-2">
                Our team designs and trains custom AI models that align with your business objectives.
              </p>
            </div>
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Integration & Deployment
              </h3>
              <p className="text-gray-300 mt-2">
                We seamlessly integrate the solution into your existing systems, ensuring scalability and security.
              </p>
            </div>
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Ongoing Optimization
              </h3>
              <p className="text-gray-300 mt-2">
                Our commitment continues post-deployment with continuous monitoring and support.
              </p>
            </div>
          </div>
        </section>

        {/* Call-to-Action */}
        <section className="text-center">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4">
            Transform Your Business with AI
          </h2>
          <p className="text-gray-300 mb-8">
            Embrace innovation with AIOrbis and let our AI Solutions revolutionize your enterprise.
          </p>
          <a
            href="/contact"
            className="px-8 py-3 bg-green-600 hover:bg-green-500 text-white font-mono rounded-lg transition-colors duration-300"
          >
            Get in Touch
          </a>
        </section>
      </div>
    </section>
  );
};

export default AISolutionsPage;
